export default
{
    values:{
        count:1,
        visualRange:0.75046,
        protectedRange:0.38377,
        enviromentVision:0.5,
        objectAvoidFactor:1,
        cohesionFactor:0.00408,
        matchingFactor:0.06312,
        seperationFactor:0.19269,
        
        minSpeed:2.379,
        maxSpeed:5.206,
        wallTransparent:false,
        turnFactor:0.201,
        
    },
    vision:
    {
        count:101,
        rayAngleLimit:0.115,
        far:0.5
    }
}